// extracted by mini-css-extract-plugin
export var cardLayout = "_9i-1";
export var paginationContainer = "_9i-0";